module.exports = __webpack_public_path__ + "static/img/Mobile-and-VirtualGames.43f8477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/Mobile-and-VirtualGames.png
// module id = N5SN
// module chunks = 1